import { render, staticRenderFns } from "./TaxSubsidies.vue?vue&type=template&id=1a4bc652&scoped=true&"
import script from "./TaxSubsidies.vue?vue&type=script&lang=js&"
export * from "./TaxSubsidies.vue?vue&type=script&lang=js&"
import style0 from "./TaxSubsidies.vue?vue&type=style&index=0&id=1a4bc652&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4bc652",
  null
  
)

export default component.exports